import { Card, CardBody, Col, ListGroup, ListGroupItem } from "reactstrap";
import { HorizontalListTitle } from "../../../constants";
import { HorizontalColor, HorizontalListData, HorizontalListSubTitle } from "../../../data/uiKits/Lists";
import CommonCardHeader from "../../../coreComponents/CommonCardHeader";

const HorizontalList = () => {
  return (
    <Col xxl="6" xs="12" className="box-col-12">
      <Card>
        <CommonCardHeader title={HorizontalListTitle} span={HorizontalListSubTitle} />
        <CardBody>
          <div className="horizontal-list-wrapper dark-list">
            {HorizontalListData &&
              HorizontalListData.map((item, index) => (
                <ListGroup className={`fw-bold list-content ${item.class}`} key={index}>
                  {item.data &&
                    item.data.map((data, i) => (
                      <ListGroupItem className={`${i === 0 && HorizontalColor[index]}`} key={i}>
                        {data}
                      </ListGroupItem>
                    ))}
                </ListGroup>
              ))}
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};
export default HorizontalList;
